import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { BrandsDataType } from "../../../../interfaces/admin.interface";
import { BrandsService } from "../../../../services/brands.service";

interface BrandSelectProps {
  setFieldValue: (field: string, value: any) => void;
  brand_id: number | null;
  selectedName: string | undefined;
  setSelectedName: (value: string | undefined) => void;
}

const SelectBrand: React.FC<BrandSelectProps> = ({
  setFieldValue,
  brand_id,
  selectedName,
  setSelectedName,
}) => {
  const [brands, setBrands] = useState<BrandsDataType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(true);
    BrandsService.getAllBrands()
      .then((response) => {
        setBrands(response?.data?.data);
        const selectedBrand = response?.data?.data?.find(
          (element: BrandsDataType) => element.id === brand_id
        );
        setSelectedName(selectedBrand?.name);
      })
      .finally(() => setLoading(false));
  }, [brand_id, setSelectedName]);

  return (
    <Select
      style={{ width: "100%", height: "46px" }}
      placeholder={loading ? "Brendlər yüklənir..." : "Brend seçin"}
      options={brands?.map((element) => ({
        label: element.name,
        value: element.name,
      }))}
      value={selectedName}
      onChange={(newName) => {
        setSelectedName(newName);
        const selectedBrand = brands.find(
          (element) => element.name === newName
        );
        if (selectedBrand) {
          setFieldValue("brand_id", selectedBrand.id);
        }
      }}
    />
  );
};

export default SelectBrand;
